import React from 'react';
import symptomsImg from '../img/Symptoms.png';
import sendImg from '../img/Send.png';
import mask1Img from '../img/Mask1.png';
import mask2Img from '../img/Mask2.jpg';
import stayHomeImg from '../img/StayHome.png';
import washYourHandsImg from '../img/WashYourHands.png';
import wipeYourPhoneImg from '../img/WipeYourPhone.png';
import { Link, Router } from 'react-router-dom';

export default function RecommendLanding() {

  return (
    <div className='content'>
      <div className='recommendcontent'>

        <section 
          className='symptoms recommendsection'
          style={{
            backgroundImage: `url(${symptomsImg})`,
          }}
          >
          
          <div className='symptomsblock block'>
            <h1>Каковы симптомы заболевания, вызванного новым коронавирусом?</h1>
          
            <ul>
              <li>Чувство усталости</li>
              <li>Затруднённое дыхание</li>
              <li>Высокая температура</li>
              <li>Кашель</li>
              <li>Боль в горле</li>
            </ul>

            <p>
              Симптомы во многом сходны со многими респираторными заболеваниями,
              часто имитируют обычную простуду, могут походить на грипп.
            </p>


          </div>
        </section>

        <section
          className='send recommendsection'
          style={{
            backgroundImage: `url(${sendImg})`,
          }}
          >
          
          <div className='sendblock block'>
            <h1>Как передаётся коронавирус?</h1>
            <p>
              Как и другие респираторные вирусы, коронавирус распространяется
              через капли, которые образуются, когда инфицированный человек
              кашляет или чихает.
            </p>


            <p>
              Кроме того, он может распространяться, когда кто-то касается
              любой загрязнённой поверхности, например дверной ручки. Люди
              заражаются, когда они касаются загрязнёнными руками рта, носа
              или глаз.
            </p>
          </div>

        </section>

        <section
          className='protect recommendsection'
          style={{
            backgroundImage: `url(${washYourHandsImg})`,
          }}
          >
          
          <div className='protectblock block'>
            <h1>Как защитить себя от заражения?</h1>
            <p>
              <ul>
                <li>Держите руки в чистоте, часто мойте их водой
                  с мылом или используйте дезинфицирующее средство.
                </li>
                <li>Также старайтесь не касаться рта, носа или глаз
                  немытыми руками (обычно такие прикосновения неосознанно
                  совершаются нами в среднем 15 раз в час).
                </li>
                <li>Будьте особенно осторожны, когда находитесь в людных местах,
                  аэропортах и других системах общественного транспорта. Максимально
                  сократите прикосновения к находящимся в таких местах поверхностям
                  и предметам, не касайтесь лица.
                </li>
                <li>
                  Носите с собой одноразовые салфетки и всегда прикрывайте нос и рот,
                  когда вы кашляете или чихаете, обязательно утилизируйте их после
                  использования.
                </li>
                <li>На работе регулярно очищайте поверхности и устройства, к которым
                  вы прикасаетесь (клавиатура компьютера, панели оргтехники общего 
                  использования, экран смартфона, пульты, дверные ручки и поручни).
                </li>
              </ul>
            </p>


           
          </div>

        </section>

        <section
          className='mask recommendsection'
          style={{
            backgroundImage: `url(${mask2Img})`,
          }}
          >
          
          <div className='maskblock block'>
            <h1>Как правильно носить медицинскую маску?</h1>
            <p>
              Аккуратно закройте нос и рот маской и закрепите её так,
              чтобы уменьшить зазор между лицом и маской.
            </p>


            <p>
              Не прикасайтесь к маске во время использования. После прикосновения
              к использованной маске, например, чтобы снять её, вымойте руки.
            </p>

            <p>
              После того, как маска станет влажной или загрязнённой, наденьте
              новую чистую и сухую маску.
            </p>

            <p>
              Не используйте повторно одноразовые маски. Их следует утилизировать
              после каждого использования сразу после снятия.
            </p>
          </div>
        </section>

        <section
          className='home recommendsection'
          style={{
            backgroundImage: `url(${stayHomeImg})`,
          }}
          >
          
          <div className='homeblock block'>
            <h1>Что можно сделать дома?</h1>
            <ul>
              <li>Расскажите детям о профилактике коронавируса.</li>
              <li>Объясните детям, как распространяются микробы, и почему
                важна хорошая гигиена рук и лица.
              </li>
              <li>Убедитесь, что у каждого в семье есть своё полотенце, 
                напомните, что нельзя делиться зубными щётками и другими предметами
                личной гигиены.
              </li>
              <li>Чаще проветривайте помещение.</li>
            </ul>
          </div>

        </section>
      </div>
    </div>
  );
}
